import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    users: [],
    user: {},
    wxQRCode: "",
    sessionUser: {},
    pagination: {},
    searchCondition: {},
    showDetailModal: false,
    showPasswordChangeModal: false,
    showPasswordResetModal: false,
    showWXQRCodeModal: false,
    broker:{}
};

const AccountUserReducer = (state = initialState, action = 'none') => {
    switch (action.type) {
        case ActionTypes.USER_LOADING:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            });
        case ActionTypes.USER_REFRESH_SEARCH_CONDITION:
            return Object.assign({}, state, {
                searchCondition: action.searchCondition
            });
        case ActionTypes.USER_TOGGLE_DETAIL_MODAL:
            return Object.assign({}, state, {
                showDetailModal: action.showDetailModal
            });
        case ActionTypes.USER_TOGGLE_PASSWORD_CHANGE_MODAL:
            return Object.assign({}, state, {
                showPasswordChangeModal: action.showPasswordChangeModal
            });
        case ActionTypes.USER_TOGGLE_PASSWORD_RESET_MODAL:
            return Object.assign({}, state, {
                showPasswordResetModal: action.showPasswordResetModal
            });
        case ActionTypes.USER_TOGGLE_WX_QR_CODE_MODAL:
            return Object.assign({}, state, {
                showWXQRCodeModal: action.showWXQRCodeModal
            });
        case ActionTypes.USER_REFRESH_WX_QR_CODE:
            return Object.assign({}, state, {
                wxQRCode: action.wxQRCode
            });
        case ActionTypes.USER_REFRESH_USER:
            return Object.assign({}, state, {
                user: action.user
            });
        case ActionTypes.USER_REFRESH_SESSION_USER:
            return Object.assign({}, state, {
                sessionUser: action.sessionUser
            });
        case ActionTypes.USER_SEARCH:
            return Object.assign({}, state, {
                users: action.users,
                pagination: action.pagination
            });
        case ActionTypes.USER_REFRESH_CREATE_USER:
            return Object.assign({}, state, {
                createUser: action.createUser
            });
        case ActionTypes.USER_REFRESH_BROKER:
            return Object.assign({}, state, {
                broker: action.broker
            });
        default:
            return state
    }
};

export default AccountUserReducer;